import {
  migrateMargin,
  migrateMobileMargin,
} from 'tools/commands/migrate/utils/migrateUtils'
import { OldEntityInterface } from 'common/types/entities/OldEntityInterface'
import { createAgreement } from 'src/shared/entities/agreement/create-agreement'

export function migrateAgreement(entity: OldEntityInterface) {
  const agreement = createAgreement(entity.parentId, entity.masterBlockId)

  agreement.id = entity.id
  agreement.htmlAttrId = entity.options.attrId

  if (entity.options.appearance) {
    agreement.appearance = entity.options.appearance
  }

  // margins
  migrateMargin(agreement, entity)
  migrateMobileMargin(agreement, entity)

  return agreement
}
